import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import Helmet from 'react-helmet';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { loggedOutDraftApproval } from 'redux/modules/draftPosts';
import { LoggedOutLayout } from 'containers';
import Dialog from 'material-ui/Dialog';
import { Step, Stepper, StepLabel, StepContent } from 'material-ui/Stepper';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import { EmptyState, MiniTabBar, PostPlatformPreview, PageHeader } from 'components';
import DraftApproval from './DraftApproval';
import * as styles from './LoggedOutDraftApproval.scss';
import { connect } from 'react-redux';
var LoggedOutDraftApproval = (_dec = connect(function (state, props) {
  return {
    posts: state.draftPosts.posts,
    approvingDraft: state.draftPosts.loggedOutDraftApprovalInProgress
  };
}, {
  loggedOutDraftApproval: loggedOutDraftApproval
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(LoggedOutDraftApproval, _Component);

  var _super = _createSuper(LoggedOutDraftApproval);

  function LoggedOutDraftApproval(props) {
    var _this;

    _classCallCheck(this, LoggedOutDraftApproval);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleFeedbackSent", function (draftPostId) {
      _this.setState({
        draftFeedbackSentFor: [].concat(_toConsumableArray(_this.state.draftFeedbackSentFor), [draftPostId.toString()])
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderThankYouScreen", function () {
      return /*#__PURE__*/React.createElement(EmptyState, {
        text: "Thank you for reviewing this content!",
        iconName: "fa fa-thumbs-o-up",
        style: {
          marginTop: 24
        }
      });
    });

    _this.state = {
      stepIndex: 0,
      draftFeedbackSentFor: []
    };
    return _this;
  }

  _createClass(LoggedOutDraftApproval, [{
    key: "isAtEnd",
    value: function isAtEnd(step) {
      if (!this.props.posts) {
        return null;
      }

      return parseInt(step) === this.props.posts.length - 1;
    }
  }, {
    key: "renderStepActions",
    value: function renderStepActions(step) {
      var _this2 = this;

      if (!this.props.posts) {
        return null;
      }

      var atEnd = parseInt(step) === this.props.posts.length - 1;
      var atBeginning = parseInt(step) === 0;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          margin: '12px 0',
          paddingTop: 24,
          borderTop: '1px solid rgb(189, 189, 189)'
        }
      }, !atEnd && /*#__PURE__*/React.createElement(RaisedButton, {
        label: "Next",
        disableTouchRipple: true,
        disableFocusRipple: true,
        secondary: true,
        onClick: function onClick() {
          _this2.setState({
            stepIndex: _this2.state.stepIndex + 1
          });
        },
        style: {
          marginRight: 12
        }
      }), step > 0 && /*#__PURE__*/React.createElement(FlatButton, {
        label: "Back",
        disabled: this.state.stepIndex === 0,
        disableTouchRipple: true,
        disableFocusRipple: true,
        onClick: function onClick() {
          if (!atBeginning) {
            _this2.setState({
              stepIndex: _this2.state.stepIndex - 1
            });
          }
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var posts = this.props.posts;

      if (!posts) {
        return null;
      }

      var allPostsApproved = true;
      posts.forEach(function (p) {
        if (!p.DraftPost.approvedAt) {
          allPostsApproved = false;
        }
      });
      return /*#__PURE__*/React.createElement(LoggedOutLayout, {
        showNavBar: true
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Approve Draft Post"
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.wrap
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Draft Post Approval",
        style: {
          marginBottom: 16
        }
      }), /*#__PURE__*/React.createElement("div", null, allPostsApproved ? /*#__PURE__*/React.createElement("div", {
        className: styles.approvedText
      }, posts.length > 1 ? 'These posts are all' : 'This post is', " approved now!") : /*#__PURE__*/React.createElement("div", {
        className: styles.approvalText
      }, "The post", !!posts.length && posts.length === 1 ? ' below is' : 's below are', " ready to be scheduled to your social accounts. Review the previews below and then click the 'Approved' or 'Needs Changes' button.")), !!posts.length && posts.length === 1 && /*#__PURE__*/React.createElement(DraftApproval, {
        isLast: true,
        post: posts[0],
        postHash: this.props.params.postHash,
        handleFeedbackSent: this.handleFeedbackSent
      }), !!posts.length && posts.length > 1 && /*#__PURE__*/React.createElement(Stepper, {
        activeStep: this.state.stepIndex,
        orientation: "vertical",
        linear: false
      }, posts.map(function (p, index) {
        return /*#__PURE__*/React.createElement(Step, null, /*#__PURE__*/React.createElement(StepLabel, {
          style: {
            cursor: 'pointer'
          },
          icon: p.DraftPost.approvedAt ? /*#__PURE__*/React.createElement("i", {
            className: "fa fa-check-circle",
            style: {
              color: '#417505',
              fontSize: 24
            }
          }) : _this3.state.draftFeedbackSentFor.includes(p.DraftPostId.toString()) ? /*#__PURE__*/React.createElement("i", {
            className: "fa fa-times-circle",
            style: {
              color: '#e74c3c',
              fontSize: 24
            }
          }) : /*#__PURE__*/React.createElement("i", {
            className: "fa fa-circle-o",
            style: {
              color: '#417505',
              fontSize: 24
            }
          }),
          onClick: function onClick() {
            _this3.setState({
              stepIndex: index
            });
          }
        }, "Post ".concat(index + 1)), /*#__PURE__*/React.createElement(StepContent, null, /*#__PURE__*/React.createElement(DraftApproval, {
          handleFeedbackSent: _this3.handleFeedbackSent,
          post: p,
          postHash: _this3.props.params.postHash,
          gotoNext: function gotoNext() {
            if (_this3.isAtEnd(index)) {
              toast.success('You have reviewed all drafts.');
            }

            _this3.setState({
              stepIndex: _this3.state.stepIndex + 1
            });
          },
          isLast: _this3.isAtEnd(index)
        }), _this3.renderStepActions(index)));
      })), this.state.stepIndex === posts.length && this.renderThankYouScreen()), /*#__PURE__*/React.createElement(ToastContainer, null));
    }
  }]);

  return LoggedOutDraftApproval;
}(Component)) || _class);
export { LoggedOutDraftApproval as default };